/* global Blockly */

import React from 'react';
import PropTypes from 'prop-types';
import MobiControlCore from '../../../v1/blocks/MobiControl/MobiControlCore';
import util from '../../../../../../utils/es5Utils'

function defineBlock(context) {
    let prop = {...context};
    prop.tooltipText = "Get iOS device details value by specified key from MobiControl.";
    prop.responseText = "device details value";
    prop.responseBlockType = "text_response";
    let blockInstance = MobiControlCore(prop);

    Object.assign(blockInstance, {
        initialized: false,
        isMoving: false,

        // predefined keys
        iosKeys: [
            [' DEVICEIDENTIFIER  ', 'DEVICEIDENTIFIER'],
            [' ENROLLEDUSER_DOMAIN  ', 'ENROLLEDUSER_DOMAIN'],
            [' ENROLLEDUSER_EMAIL  ', 'ENROLLEDUSER_EMAIL'],
            [' ENROLLEDUSER_FIRST_NAME  ', 'ENROLLEDUSER_FIRST_NAME'],
            [' MODEL  ', 'MODEL'],
            [' SERIALNUM  ', 'SERIALNUM'],
            [' MANUFACTURER  ', 'MANUFACTURER'],
            [' PHONENUMBER  ', 'PHONENUMBER'],
            [' PLATFORM  ', 'PLATFORM'],
            [' IP  ', 'IP'],
            [' ENROLLEDUSER_UPN  ', 'ENROLLEDUSER_UPN'],
            [' PERSONALIZED_DEVICE_NAME  ', 'PERSONALIZED_DEVICE_NAME'],
            [' MACAddress  ', 'MACAddress']
        ],

        // override default fields
        addFields: function() {
            this.appendValueInput("KEY")
                .appendField("get iOS device details by key ")
                .setCheck(['String', 'dropdown_options']);
        },

        // change handler
        customChangeHandler: function(event) {
            // make sure key block is always connected
            let keyInput = this.getInput('KEY');
            if (keyInput.connection.isConnected()) {
                let keyTargetBlock = keyInput.connection.targetBlock();
                if (keyTargetBlock.type === 'dropdown_options' && keyTargetBlock.customColor !== Blockly.Msg.MOBICONTROL_HUE) {
                    // when rendered for the first time, the color is reset for existing block - refresh it
                    keyTargetBlock.setColour(Blockly.Msg.MOBICONTROL_HUE);
                    keyTargetBlock.customColor = Blockly.Msg.MOBICONTROL_HUE;
                }
            } else {
                // auto-create drop-down block with predefined keys
                let ddKeyBlock = this.workspace.newBlock('dropdown_options');
                ddKeyBlock.setFieldDropdown(this.iosKeys, undefined, undefined);
                ddKeyBlock.setColour(Blockly.Msg.MOBICONTROL_HUE);
                ddKeyBlock.customColor = Blockly.Msg.MOBICONTROL_HUE;
                ddKeyBlock.setShadow(true);
                if (this.rendered) {
                    ddKeyBlock.initSvg();
                    ddKeyBlock.render();
                }
                keyInput.connection.connect(ddKeyBlock.outputConnection);
            }
            this.initialized = true;

            
            if (event.type === Blockly.Events.MOVE/* there is no OnDragStarted event */ && !this.isMoving) {
                this.getChildren(false).forEach((childBlock) => {
                    childBlock.render();
                });
                this.isMoving = true;
                this.unselect(); // block appears to be selected while dragging - fixed
            }
            if (event.type === Blockly.Events.END_DRAG && this.isMoving) {
                this.getChildren(false).forEach((childBlock) => {
                    childBlock.render();
                });
                this.isMoving = false;
            }
        }
    });
    return blockInstance;
}

function defineGenerators() {
    return {
        'JavaScript': function (block) {
            let coreResponseCode = block.getJavascriptCore();
            let value = Blockly.JavaScript.valueToCode(block, "KEY", Blockly.JavaScript.ORDER_NONE);
            let valueBlock = block.getInput("KEY");
            if (valueBlock?.connection?.isConnected()
                && valueBlock.connection.targetConnection?.getSourceBlock().type === "dropdown_options") {
                value = "'" + value + "'";
            } else {
                value = "'" + util.parseString(value) + "'";
            }
            return `Snap.mcDeviceDetails.getIOSDeviceDetails(${value}, ${coreResponseCode});\n`;
        }
    }
}

const MobiControlGetIosDeviceDetailsV3 = function (props) {
    const name = 'snap_mobicontrol_getiosdevicedetails_V3';
    MobiControlGetIosDeviceDetailsV3.blockName = name;

    Blockly.Blocks[name] = defineBlock(props.context);
    let generators = defineGenerators();
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    return  <block type={name}>
            </block>;
}

MobiControlGetIosDeviceDetailsV3.propTypes = {
    context: PropTypes.object
};

export default MobiControlGetIosDeviceDetailsV3;
